import React, { memo, useEffect, useRef, useState } from "react";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Button from "@mui/material/Button";
import Logo from "../images/logo.svg";
import personIcon from "../images/person.svg";
import changepasswordSuccess from "../images/changepassword-success.png";

import {
  Checkbox,
  Container,
  FormControl,
  FormControlLabel,
  FormHelperText,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import CircleImg from "../images/circle-pattern-1.png";
import ArrowDown from "../images/arrow-down.svg";
import VisibilityOff from "../images/eye-close.svg";
import Visibility from "../images/eye-icon.svg";
import LockIcon from "../images/lock_icon.svg";
import refrechIcon from "../images/refresh-icon.svg";
import captchaIcon from "../images/re-load.svg";
import emailIcon from "../images/email-icon.svg";
import phoneIcon from "../images/phone-icon.svg";
import backIcon from "../images/back-arrow-left.svg";
import { useNavigate, Link, useLocation } from "react-router-dom";
import {
  DASHBOARD_ROUTE,
  FORGOT_PASSWORD,
  SIGNIN_ROUTE,
} from "../constants/RoutePath";
import { useFormik } from "formik";
import * as Yup from "yup";

// import {
//   loadCaptchaEnginge,
//   LoadCanvasTemplate,
//   LoadCanvasTemplateNoReload,
//   validateCaptcha,
// } from "react-simple-captcha";

import { CHANGE_PASSWORD_URL, SIGN_UP_URL, USER_FORGOTPASSWORDLINKVERIFY_URL } from "../constants/ApiRoute";
import { CustomMessage, deCryptFun, enCryptFun } from "./comman/CustomFunction";
import API from "./comman/API";
import CustomLoader from "./comman/CustomLoader";
import CustomPageLoading from "./comman/CustomPageLoading";

import Captcha from "./comman/Captcha";
import CreateNewAccountModel from "./model/CreateNewAccountModel";
import EmailSchema from "./comman/validation/EmailSchema";
import { useToast } from "./comman/CustomMessages";
import {
  allowedCharactersRegex,
  phoneNumberRegex,
} from "./comman/RegexConstant";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));
const initialValues = {
  password: "",
  confirmPassword: "",
};
const ChangePassword = () => {
  const navigate = useNavigate();
  const showToast = useToast();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  
  const cleanId = queryParams.get('id');
  const expiry = queryParams.get('expiry');
  const otp = queryParams.get('otp');

  console.log("cleanId ==>",
    cleanId,
    expiry,
    otp
  )
 

  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = React.useState(true);
  const [confirmshowPassword, confirmsetShowPassword] = React.useState(true);
  const [isExpiryDate, setIsExpiryDate] = useState(false);
  const [isAlredyVerified, setIsAlredyVerified] = useState(false);
  const [pageTitle, setPageTitle] = useState("");
  const [pageMessage, setPageMessage] = useState("");
  const [enData, setEnDate] = useState("");
  const [onChaptcha, setOnChaptcha] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const [flag, setFlag] = useState(false);
  const inputRef = useRef(null);
  const inputRefconf = useRef(null);
  const captchaRef = useRef(null);

  const checkForgotUrlIsVaild = async () => {
    
    let userId = JSON.parse(deCryptFun(cleanId));

    const config = {
      method: "GET",
      url: USER_FORGOTPASSWORDLINKVERIFY_URL,
      params: {
        flutterString: "",
        webString: enCryptFun(JSON.stringify({"userId": userId,"otp": otp})),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);

        if (v.status === "Error") {
          setIsAlredyVerified(true)
          setFlag(true)
          setPageTitle("Failed")
          return true;
        }

        // showToast(v.message, "error");
      }
    } 



  }

  const validationSchema = Yup.object({
    // email: EmailSchema.required("Email is required"),
    password: Yup.string()
      .required("Password is required")
      .min(7, "Password must be at least 7 characters")
      .matches(/[a-z]/, "Password must contain at least one lowercase letter")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/[0-9]/, "Password must contain at least one number"),
    confirmPassword: Yup.string()
      .required("Please confirm your password.")
      .oneOf([Yup.ref("password"), null], "Passwords must match"),
  });
  const {
    handleSubmit,
    handleChange,
    setValues,
    values,
    errors,
    setErrors,
    touched,
    resetForm,
    handleBlur,
    setFieldTouched,
  } = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validateOnChange: false,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      Registeruser(values);
    },
  });
  
  const handleClose = () => {
    setFlag(false);
    resetForm({});
    setValues(initialValues);
    document.getElementById("user_captcha_input").value = "";
  };
  const Registeruser = async (values) => {
    console.log("register");
    setLoading(true);
    let decryuserId = JSON.parse(deCryptFun(cleanId));
    const data = {
      userId: decryuserId,
      password: values.password,
    };
    console.log("register1");

    const config = {
      method: "PUT",
      url: CHANGE_PASSWORD_URL,
      data: {
        webString: enCryptFun(JSON.stringify(data)),
        flutterString: "",
      },
    };
    try {
      const response = await API(config);
      console.log("response", response);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      console.log("response", parsedResponse);
      if (parsedResponse.status === "Success") {
        setFlag(true);
        setValues(initialValues);
        setPageTitle("Success");
        setPageMessage("Your password has been changed successfully");
        // navigate(DASHBOARD_ROUTE);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v.message, "error");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleClickShowPassword = () => {
    const input = inputRef.current.querySelector("input");
    const cursorPosition = input.selectionStart;
    setShowPassword(!showPassword);
    requestAnimationFrame(() => {
      input.blur(); // This removes the cursor by blurring the input field
    });
    // setTimeout(() => {
    //   input.setSelectionRange(cursorPosition, cursorPosition);
    // }, 0);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleClickShowPasswordConfirm = () => {
    const input = inputRefconf.current.querySelector("input");
    const cursorPosition = input.selectionStart;
    confirmsetShowPassword(!confirmshowPassword);
    requestAnimationFrame(() => {
      input.blur(); // This removes the cursor by blurring the input field
    });
    // setTimeout(() => {
    //   input.setSelectionRange(cursorPosition, cursorPosition);
    // }, 0);
  };

  const handleMouseDownPasswordconfirm = (event) => {
    event.preventDefault();
  };

  const handleCaptchaChange = (newCaptcha) => {
    setOnChaptcha(newCaptcha);
  };

  const backFun = () => {
    window.location.replace(`/signin`);
    //navigate(SIGNIN_ROUTE);
  };

  useEffect(() => {
    
    
    if(isExpiryDate){
      setPageMessage("This password reset link has expired");
    }

    if (isAlredyVerified) {
      setPageMessage("This password reset link has already been used. If you need to reset your password again, please request a new link.");
    }

  }, [isExpiryDate, isAlredyVerified]);

  useEffect(() => {

    setLoading(true);

    

    if(cleanId && otp && expiry){

      const checkForgotUrlResponse =  checkForgotUrlIsVaild();

      if(checkForgotUrlResponse){
        setLoading(false);
        return ;
      }
      
    }

    checkExpiryDateTime(expiry);

    setLoading(false);

  }, []);

  const checkExpiryDateTime = (dateValue) => {

    const otpTriggerDate = new Date(dateValue);

    const currentDate = new Date();

    // Convert current date to UTC
    const utcCurrentDate = new Date(currentDate.toUTCString());

    // Calculate the difference in milliseconds
    const timeDifference = utcCurrentDate - otpTriggerDate;

    console.log("Data in func", otpTriggerDate, utcCurrentDate)

    const tenMinutesInMilliseconds = 10 * 60 * 1000;

    // Check if the difference is greater than 10 minutes
    if (timeDifference > tenMinutesInMilliseconds) {
      setIsExpiryDate(true)
      setFlag(true)
      setPageTitle("Failed")
    }
    
  };

  const [expanded, setExpanded] = React.useState(false);

  const handleChanges = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Grid container rowSpacing={1}>
          <Grid sx={{ p: "0 !important" }} item xs={12} md={6} lg={6}>
            <Box
              sx={{
                height: { xs: "auto", md: "98vh" },
                padding: { xs: "40px", md: "40px 59px" },
                paddingRight: { xs: "40px", md: "68px" },
                paddingTop: "46px",
              }}
              className="welcome-box"
            >
              {/* <Box className="login-bg-color login-bg-top"></Box> */}
              <img className="logo" src={Logo} />
              <h1 className="login-title">
                Welcome to
                <br /> <span className="smart-billing">
                  Smart Billing
                </span> by <br />
                HOS Resources (DEV)!
              </h1>
              <p className="login-text">
                Smart Billing is the billing solution that enables HOS Resources
                to quickly collect, consolidate, and invoice billing statements
                from brokers in the field.
              </p>
              {/* <Box className="login-bg-color login-bg-bottom"></Box> */}
              <Accordion
                expanded={expanded === "panel1"}
                onChange={handleChanges("panel1")}
                className="login-accord"
              >
                <AccordionSummary
                  expandIcon={<img src={ArrowDown} />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  About
                </AccordionSummary>
                <AccordionDetails>
                  HOS Resources, LLC (“HOS”) is a Lafayette, Louisiana based
                  energy consulting firm formed in 2015. HOS retains independent
                  contractor landmen to provide our clients with quality land
                  services throughout the country. These include title,
                  abstracting, curative, leasing, right-of-way acquisitions,
                  land acquisition, and any other services required to meet our
                  clients’ needs.
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel2"}
                onChange={handleChanges("panel2")}
                className="login-accord"
              >
                <AccordionSummary
                  expandIcon={<img src={ArrowDown} />}
                  aria-controls="panel2-content"
                  id="panel2-header"
                >
                  Leadership & Experience
                </AccordionSummary>
                <AccordionDetails>
                  HOS’s founders combine for over 34 years of industry
                  experience in negotiating and acquiring oil and gas leases,
                  right-of-ways, seismic permits and options, as well as surface
                  leases throughout the country, including Louisiana,
                  Mississippi, Alabama, Texas, Utah, Minnesota, New York and
                  Illinois. They have represented oil and gas exploration
                  companies, midstream pipeline and storage companies, renewable
                  energy developers, law firms, large landowners, working
                  interest participants, private equity funds, and banks. HOS’s
                  senior landmen have over 50 years combined industry
                  experience.
                </AccordionDetails>
              </Accordion>
            </Box>
          </Grid>
          <Grid sx={{ background: "#fff" }} item xs={12} md={6} lg={6}>
            <Box
              sx={{
                padding: {
                  xs: "40px 30px",
                  md: "40px 40px 40px 20px",
                  lg: "40px 100px 40px 76px",
                },
                pt: "42px !important",
              }}
              className="form-box login"
            >
              <Stack
                sx={{
                  mb: "14px",
                  cursor: "pointer",
                }}
                direction="row"
                spacing={0}
                justifyContent="flex-start"
                alignItems="center"
                onClick={backFun}
              >
                <img style={{ cursor: "pointer" }} src={backIcon} />
                <p className="back-text">Back</p>
              </Stack>

              {!flag ? (
                <>
                  <Typography className="form-title" variant="h2">
                    Change Your Password
                  </Typography>
                  <p className="form-text">
                    Use the form below to change password.
                  </p>
                  <Box component={"form"} onSubmit={handleSubmit}>
                    {/* <FormControl variant="standard">
                  <p className="label">Email</p>
                  <Input
                    // type="email"
                    name="email"
                    id="input-with-icon-adornment"
                    placeholder="Enter your email address"
                    startAdornment={
                      <InputAdornment position="start">
                        <img src={emailIcon} />
                      </InputAdornment>
                    }
                    value={values.email}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                      if (touched.email) {
                        setFieldTouched("email", false); // Clear touched state
                      }
                    }}
                    error={errors.email && touched.email}
                    helperText={
                      errors.email && touched.email ? errors.email : ""
                    }
                  />
                  <FormHelperText error={true}>
                    {errors.email && touched.email ? errors.email : ""}
                  </FormHelperText>
                </FormControl> */}

                    <FormControl variant="standard">
                      <p className="label">New Password</p>
                      <Input
                        name="password"
                        ref={inputRef}
                        id="outlined-adornment-password"
                        placeholder="Enter your password"
                        type={!showPassword ? "text" : "password"}
                        startAdornment={
                          <InputAdornment position="start">
                            <img src={LockIcon} />
                          </InputAdornment>
                        }
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                              {showPassword ? (
                                <img src={VisibilityOff} />
                              ) : (
                                <img src={Visibility} />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                        value={values.password}
                        onBlur={handleBlur}
                        onChange={(e) => {
                          handleChange(e);
                          if (touched.password) {
                            setFieldTouched("password", false); // Clear touched state
                          }
                        }}
                        error={errors.password && touched.password}
                        helperText={
                          errors.password && touched.password
                            ? errors.password
                            : ""
                        }
                      />
                      {/* <FormHelperText error={true}>
                    {errors.password && touched.password ? errors.password : ""}
                  </FormHelperText> */}
                      {/* <Box className="password-instruction">
                    <p
                      style={{
                        color:
                          errors.password ===
                          "Password must be at least 7 characters"
                            ? "#d32f2f"
                            : "inherit",
                      }}
                    >
                      - Min 7 characters
                    </p>
                    <p
                      style={{
                        color:
                          errors.password ===
                            "Password must contain at least one lowercase letter" ||
                          errors.password ===
                            "Password must contain at least one uppercase letter"
                            ? "#d32f2f"
                            : "inherit",
                      }}
                    >
                      - Upper & lower characters
                    </p>
                    <p
                      style={{
                        color:
                          errors.password ===
                          "Password must contain at least one number"
                            ? "#d32f2f"
                            : "inherit",
                      }}
                    >
                      - At least one digit
                    </p>
                  </Box> */}
                      {/* <Box className="password-instruction">
                        <p
                          style={{
                            color:
                              values.password.length >= 7
                                ? "#58a84a"
                                : touched.password && values.password.length < 7
                                ? "#d32f2f" // Red color for error
                                : !errors.password
                                ? "#inherit"
                                : "", // Default color when not an error
                          }}
                        >
                          - Min 7 characters
                        </p>

                        <p
                          style={{
                            color:
                              /[A-Z]/.test(values.password) &&
                              /[a-z]/.test(values.password)
                                ? "#58a84a"
                                : touched.password &&
                                  (!/[a-z]/.test(values.password) ||
                                    !/[A-Z]/.test(values.password))
                                ? "#d32f2f" // Red color for error
                                : !errors.password
                                ? "#inherit"
                                : "", // Default color when not an error
                          }}
                        >
                          - Upper & lower characters
                        </p>
                        <p
                          style={{
                            color: /\d/.test(values.password)
                              ? "#58a84a"
                              : touched.password && !/\d/.test(values.password)
                              ? "#d32f2f" // Red color for error
                              : !errors.password
                              ? "#inherit"
                              : "", // Default color when not an error
                            marginBottom: "0px",
                          }}
                        >
                          - At least one digit
                        </p>
                      </Box> */}

<Box className="password-instruction">
                    <p
                      style={{
                        color:
                          values.password === ""
                            ? "inherit"
                            : values.password.length >= 7
                            ? "green"
                            : (errors.password ===
                                "Password must be at least 7 characters" &&
                                touched.password) ||
                              values.password.length > 0
                            ? "#d32f2f"
                            : "inherit",
                      }}
                    >
                      - Min 7 characters
                    </p>
                    <p
                      style={{
                        color:
                          values.password === ""
                            ? "inherit"
                            : /[a-z]/.test(values.password) &&
                              /[A-Z]/.test(values.password)
                            ? "green"
                            : ((errors.password ===
                                "Password must contain at least one lowercase letter" ||
                                errors.password ===
                                  "Password must contain at least one uppercase letter") &&
                                touched.password) ||
                              values.password.length > 0
                            ? "#d32f2f"
                            : "inherit",
                      }}
                    >
                      - Upper & lower characters
                    </p>
                    <p
                      style={{
                        color:
                          values.password === ""
                            ? "inherit"
                            : /\d/.test(values.password)
                            ? "green"
                            : (errors.password ===
                                "Password must contain at least one number" &&
                                touched.password) ||
                              values.password.length > 0
                            ? "#d32f2f"
                            : "inherit",
                        marginBottom: "0px",
                      }}
                    >
                      - At least one digit
                    </p>
                  </Box>
                    </FormControl>
                    <FormControl variant="Input">
                      <p className="label">Confirm Password</p>
                      <Input
                        name="confirmPassword"
                        placeholder="Re-enter password"
                        id="outlined-adornment-password"
                        type={!confirmshowPassword ? "text" : "password"}
                        ref={inputRefconf}
                        onBlur={handleBlur}
                        startAdornment={
                          <InputAdornment position="start">
                            <img src={LockIcon} />
                          </InputAdornment>
                        }
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPasswordConfirm}
                              onMouseDown={handleMouseDownPasswordconfirm}
                              edge="end"
                            >
                              {confirmshowPassword ? (
                                <img src={VisibilityOff} />
                              ) : (
                                <img src={Visibility} />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                        value={values.confirmPassword}
                        onChange={(e) => {
                          handleChange(e);
                          if (touched.confirmPassword) {
                            setFieldTouched("confirmPassword", false); // Clear touched state
                          }
                        }}
                        error={
                          errors.confirmPassword && touched.confirmPassword
                        }
                        helperText={
                          errors.confirmPassword && touched.confirmPassword
                            ? errors.confirmPassword
                            : ""
                        }
                      />
                      <FormHelperText error={true}>
                        {errors.confirmPassword && touched.confirmPassword
                          ? errors.confirmPassword
                          : ""}
                      </FormHelperText>
                    </FormControl>

                    <Button
                      sx={{ mt: "2px !important" }}
                      className="login-btn"
                      variant="contained"
                      size="large"
                      type="submit"
                      disabled={loading}
                    >
                      {loading && <CustomLoader loading={loading} />}
                      Change Password
                    </Button>
                    <p className="account">
                      Remember Password?&nbsp;
                      <Link className="link" to={SIGNIN_ROUTE} underline="none">
                        Login
                      </Link>
                    </p>
                  </Box>
                </>
              ) : (
                <>
                  <Box
                    sx={{
                      textAlign: "center",
                      mt: { xs: "40px", md: "120px" },
                    }}
                  >
                    <img
                      style={{ maxWidth: "218px", width: "100%" }}
                      className="logo"
                      src={changepasswordSuccess}
                    />

                  {loading && <CustomPageLoading />}

                    <Typography
                      sx={{ mt: "-7px" }}
                      className="password-title"
                      variant="h2"
                    >
                      {pageTitle}
                    </Typography>

                    <p className="password-subtext">
                    {pageMessage}
                    </p>

                    <Button
                      sx={{
                        padding: "11px 15px !important",
                        width: "auto !important",
                        mt: "12px !important",
                      }}
                      className="login-btn"
                      variant="contained"
                      size="large"
                      onClick={backFun}
                    >
                      Back to login
                    </Button>
                  </Box>
                </>
              )}
            </Box>
          </Grid>
          {/* {flag && (
            <CreateNewAccountModel
              open={flag}
              handleClose={handleClose}
              message={
                " Thank you for registering. Please check your email for the confirmation email and follow the instructions for validating your email."
              }
            />
          )} */}
        </Grid>
      </Box>
    </>
  );
};

export default ChangePassword;
